<div class="fdx-c-modal">
  <div class="fdx-c-modal__backdrop"></div>
  <div class="fdx-c-modal__main fdx-c-modal__main--medium" role="dialog" aria-modal="true">
    <div class="fdx-c-modal__body">

      <p class="fdx-c-modal__description fdx-u-color--blue font-weight-bold ">
        {{popupContent}}
      </p>

      <div class="asn-table-container">
        <table class="fdx-c-table">
          <thead>
            <tr>
              <th>ASN Numbers</th>
              <th>PO Numbers</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of asnList">
              <td>{{ row.asnNumber }}</td>
              <td>{{ row.poNumber}}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="fdx-u-mt--4 fdx-u-mb--2 float-right">
        <button class="fdx-c-button fdx-c-button--text fxg-margin-right" (click)="onCancel()">
          Cancel
        </button>
       
      </div>

    </div>
  </div>
</div>